import React, { forwardRef } from 'react'
import styles from './Input.module.scss'
import cl from 'classnames'
import { InputProps } from './Input.types'
import { Text1 } from '../Text1'
import { ChangeMarkPoint } from '../ChangeMarkPoint'
import { useInputExtraPaddingLeft } from 'utilities'
import { RedMarkedText } from '../RedMarkedText'

const InputComponent = (props: InputProps, ref: React.LegacyRef<HTMLInputElement>) => {
  const {
    errorMessage,
    onChange,
    onChangeNumber,
    containerProps: {
      className,
      style
    } = {},
    unitsText,
    label,
    labelIcon: LabelIcon,
    labelPosition = 'top',
    labelProps,
    value,
    versionChange,
    step = 1,
    ...rest
  } = props

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange && !onChangeNumber) return
    const { value } = event.target
    onChange && onChange(value)

    if (!onChangeNumber) return
    try {
      const numValue = Number(value)
      onChangeNumber(numValue)
    } catch (error) {
      console.error(error)
      onChangeNumber(null)
    }
  }

  const {
    versionBeforeValueRef,
    paddingLeft
  } = useInputExtraPaddingLeft()

  return (
    <div
      className={cl(styles.container, styles[`${labelPosition}Label`], {
        [styles.error]: errorMessage || versionChange
      }, className)}
      style={style}
    >
      {Boolean(label || labelProps) && (
        <Text1
          bold
          style={{ marginBottom: labelPosition === 'top' ? 6 : undefined }}
          {...(labelProps || {})}
        >
          {LabelIcon && (
            <LabelIcon
              style={{
                marginRight: 10.5,
                fill: styles.primary
              }}
            />
          )}
          {label || (labelProps || {}).children}
        </Text1>
      )}
      <input
        onChange={handleChange}
        value={value === 0 ? value : value || ''}
        {...rest}
        className={cl(styles.input, {
          [styles.colorRed]: versionChange
        }, rest.className)}
        style={{
          paddingLeft,
          ...rest.style
        }}
        step={step}
        ref={ref}
      />

      {versionChange?.valueBeforeChange && (
        <RedMarkedText ref={versionBeforeValueRef}>
          {versionChange.valueBeforeChange}
        </RedMarkedText>
      )}

      {unitsText && <div className={styles.unitsText}>{unitsText}</div>}
      {versionChange && <ChangeMarkPoint {...versionChange} />}
      {errorMessage && <span>{errorMessage}</span>}
    </div>
  )
}

const Input = forwardRef(InputComponent)
export { Input }
